/**
 * Lokální datumové helpery terénu (UX audit A3.2, B8.3, TOP 10): mistr 50+
 * nesmí luštit `07/08/2026` — termíny se vybírají rychlými volbami
 * (Zítra/Pozítří) a zobrazují česky „st 8. 7. 2026". Drženo POD pages/teren/,
 * aby se nekřížilo s kancelářskou vlnou (lib/format.ts se tu nemění).
 */

/** Dnešek + n dní v lokálním čase klienta (YYYY-MM-DD). */
export function denPlus(n: number): string {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
    d.getDate(),
  ).padStart(2, '0')}`;
}

/** Dnešní den v lokálním čase (YYYY-MM-DD) — den založení nálezu apod. */
export const dnesniDen = (): string => denPlus(0);

/** „2026-07-08" (lokální den) → „st 8. 7. 2026" — jednoznačné české datum. */
export function formatTermin(datum: string): string {
  const d = new Date(`${datum}T00:00:00`);
  if (Number.isNaN(d.getTime())) return datum;
  const den = d.toLocaleDateString('cs-CZ', { weekday: 'short' });
  return `${den} ${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
}

/** ISO/UTC datum → název dne v týdnu s velkým písmenem („Úterý"). */
export function denVTydnu(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const den = d.toLocaleDateString('cs-CZ', { weekday: 'long', timeZone: 'UTC' });
  return den.charAt(0).toUpperCase() + den.slice(1);
}

/**
 * ISO datum/čas (API, UTC půlnoc u @db.Date) → „Pátek 4. 7." — pro proužek
 * nepodepsaného dne (A1.5). Formátuje se v UTC shodně s lib/format.formatDen.
 */
export function formatDenSTydnem(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const den = d.toLocaleDateString('cs-CZ', { weekday: 'long', timeZone: 'UTC' });
  const denVelke = den.charAt(0).toUpperCase() + den.slice(1);
  return `${denVelke} ${d.getUTCDate()}. ${d.getUTCMonth() + 1}.`;
}

/**
 * Termín úkolu/vady/výzvy (ISO z API) pro seznamy: české datum + lidská
 * přípona „dnes / zítra / pozítří / po termínu" (TOP 10, B8.4 jazykem terénu).
 */
export function terminInfo(iso: string): {
  text: string;
  pripona: 'dnes' | 'zítra' | 'pozítří' | 'po termínu' | null;
  poTerminu: boolean;
} {
  const den = iso.slice(0, 10);
  const text = formatTermin(den);
  if (den < dnesniDen()) return { text, pripona: 'po termínu', poTerminu: true };
  if (den === dnesniDen()) return { text, pripona: 'dnes', poTerminu: false };
  if (den === denPlus(1)) return { text, pripona: 'zítra', poTerminu: false };
  if (den === denPlus(2)) return { text, pripona: 'pozítří', poTerminu: false };
  return { text, pripona: null, poTerminu: false };
}

/** České skloňování počtu: mnozstvi(1, 'zápis', 'zápisy', 'zápisů'). */
export function sklonuj(n: number, jeden: string, dvaAzCtyri: string, vice: string): string {
  if (n === 1) return jeden;
  if (n >= 2 && n <= 4) return dvaAzCtyri;
  return vice;
}
